<template>
  <ConfirmationDialog
    x_small
    :disabled="loading || disabled"
    :loading="loading"
    headerClass="modal-header-i"
    message-title="Excluir"
    open-text=""
    message-body="Deseja realmente excluir o faturamento da venda? Ao confirmar, o faturamento vai ficar com status pendente."
    open-class="btn-delete"
    open-left-icon="fa-trash"
    @yes="handleDelete"
  />
</template>

<script>
import ConfirmationDialog from "../../../../Components/ConfirmationDialog";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

export default {
  name: "Delete",

  components: {
    ConfirmationDialog,
  },

  props: {
    item: Object,
    disabled: Boolean,
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async handleDelete() {
      try {
        this.loading = true;

        const {
          item: { finance_launch_bills_to_pay_id },
        } = this;

        let data = { finance_launch_bills_to_pay_id };

        const response = await api.delete(
          "/rest-home/financial/launch/pay-stock-sale",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
        } else {
          this.$emit("errors", errors);
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>